import { Component, inject } from '@angular/core';
import { AppTranslateService } from '../core/services/app.translate.service';
import { RouterOutlet } from '@angular/router';
import { Toolbar } from './shared';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toolbar],
  providers: [],
  templateUrl: './app.html',
  standalone: true,
})
export class App {
  public translate = inject(AppTranslateService);

  constructor() {
    this.translate.setLanguage();
  }
}
